var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// libs
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
//dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
import { IconCicularLoader } from '@/constants/icons/svg';
//includes
import { getCampaignApi } from '@/includes/api/campaign/get';
import { getMetricsApi } from '@/includes/api/metrics';
//stores
import useReadCampaignStore from '@/stores/ReadCampaign';
import useCampaignDetailsStore from '@/stores/CampaignDetails';
import useAccountStore from '@/stores/account';
//style
import style from './index.module.scss';
// defs
import { AdvertiserDimensions } from '@local/typedefs/dist/protos/campaign/AdvertiserMetrics';
// components
import IndexPageContent from './IndexPageContent';
import { WithNotificationBar } from '@/widgets/NotificationBar';
const Index = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const { campaign, setCampaign } = useReadCampaignStore((state) => ({
        campaign: state.campaign,
        setCampaign: state.setCampaign,
    }));
    const { setAggregateMetrics, setCampaignPerformanceData, clearDetailsStore, } = useCampaignDetailsStore((state) => ({
        setAggregateMetrics: state.setAggregateMetrics,
        setCampaignPerformanceData: state.setCampaignPerformanceData,
        clearDetailsStore: state.clear,
    }));
    const getCurrentAccountId = useAccountStore((state) => state.getCurrentAccountId);
    const { id: paramsCampaignId } = useParams();
    const getCampaign = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!paramsCampaignId)
            return;
        const accountId = yield getCurrentAccountId();
        const campaign = yield getCampaignApi({
            campaignId: paramsCampaignId,
            accountId,
        });
        if (campaign) {
            setCampaign(campaign);
        }
    });
    const getAggregateMetrics = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!paramsCampaignId)
            return;
        const accountId = yield getCurrentAccountId();
        const aggregateMetrics = yield getMetricsApi({
            campaignIds: [paramsCampaignId],
            dimensions: [AdvertiserDimensions.DIMENSION_CAMPAIGN],
            accountId,
        });
        if (aggregateMetrics) {
            setAggregateMetrics(aggregateMetrics.metrics.metricsOnDimension[0].metrics);
        }
    });
    const getCampaignPerformance = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!paramsCampaignId)
            return;
        const accountId = yield getCurrentAccountId();
        const dayWisePerformance = yield getMetricsApi({
            campaignIds: [paramsCampaignId],
            dimensions: [
                AdvertiserDimensions.DIMENSION_CAMPAIGN,
                AdvertiserDimensions.DIMENSION_DAY,
            ],
            accountId,
            interval: {
                startTime: dayjs().subtract(7, 'day').toISOString(),
                endTime: dayjs().subtract(1, 'day').toISOString(),
            },
        });
        if (dayWisePerformance) {
            setCampaignPerformanceData(dayWisePerformance.metrics.metricsOnDimension);
        }
    });
    const checkAndFetchCampaignDetails = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setIsLoading(true);
            clearDetailsStore();
            const promises = [
                getCampaign(),
                getAggregateMetrics(),
                getCampaignPerformance(),
            ];
            yield Promise.all(promises);
        }
        catch (_a) {
            setIsError(true);
        }
        finally {
            setIsLoading(false);
        }
    });
    /**
     * TODO: move this to a helper
     */
    useEffect(() => {
        checkAndFetchCampaignDetails();
    }, []);
    return (React.createElement("div", { className: style.container },
        isLoading && !isError && (React.createElement("div", { className: style.containerCenter },
            React.createElement(IconCicularLoader, { height: 108, width: 108, className: style.loader }),
            React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Reg, color: DlsColorTokens.text_Med_Emphasis }, "Loading Details"))),
        !isLoading && (isError || !campaign) && (React.createElement("div", { className: style.containerCenter },
            React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Bold, color: DlsColorTokens.text_Med_Emphasis }, "Something went wrong!"))),
        !isLoading && !isError && campaign && React.createElement(IndexPageContent, null)));
};
export default WithNotificationBar(Index);
